// for add employee

export const RESET_EDIT_USER_DETAILS = "reset_edit_user_details";
export const EDIT_USER_DETAILS = "edit_user_details";
export const EDIT_USER_DETAILS_SUCCESS = "edit_user_details_success";
export const EDIT_USER_DETAILS_FAILURE = "edit_user_details_failure";
